import React, { useEffect, useState } from 'react';
import { Modal, Table, TablePaginationConfig, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAuditlogData } from '../../store/reducers/userDashboardSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import moment from 'moment';

interface AuditLogModalProps {
  visible: boolean;
  onCancel: () => void;
  selectedemployeeData: any;
  tabName: string;
}

const AuditLogModal: React.FC<AuditLogModalProps> = ({ visible, onCancel, selectedemployeeData, tabName }) => {
  const dispatch = useDispatch();
  const [auditLogData, setAuditLogData] = useState<any>([]);
  const userDashboard = useSelector((state: any) => state.userDashboard);
  const [employeeName, setEmployeeName] = useState<string>('');
  const [employeeEmail, setEmployeeEmail] = useState<string>('');
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  useEffect(() => {
    if (visible) {
      fetchAuditLogDataWithPagination(pageNo, pageSize);
    } else {
      setAuditLogData([]);
      setTotalCount(0);
      setPageNo(0);
      setPageSize(10);
    }
  }, [visible, selectedemployeeData, tabName, pageNo, pageSize]);

  useEffect(() => {
    if (userDashboard.auditloglist) {
      setAuditLogData(userDashboard.auditloglist);
    }
  }, [userDashboard.auditloglist]);

  useEffect(() => {
    setEmployeeName(selectedemployeeData.employeeName ? selectedemployeeData.employeeName : '');
    setEmployeeEmail(selectedemployeeData.employeeEmail ? selectedemployeeData.employeeEmail : '');
  }, [selectedemployeeData.employeeName, selectedemployeeData.employeeEmail]);

  const fetchAuditLogDataWithPagination = (page: number, size: number) => {
    dispatch(fetchAuditlogData({ employeeId: selectedemployeeData.employeeId, page, size })).then(
      (response: any) => {
        if (response.type !== 'request/fetchAuditlogData/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else{
            setTotalCount(response.payload.totalElements);
        }
      }
    );
  };

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'createdDate',
      key: 'createdDate',
      width: 150,
      render: (text: string, record: any) => (
        <span>{record.createdDate && moment(record.createdDate.toString()).format('YYYY-MM-DD')}</span>
      ),
    },
    {
      title: 'Change',
      dataIndex: 'change',
      key: 'change',
      width: 150,
    },
    {
      title: 'Old Value',
      dataIndex: 'oldValue',
      key: 'oldValue',
      width: 150,
    },
    {
      title: 'New Value',
      dataIndex: 'newValue',
      key: 'newValue',
      width: 150,
    },
    {
      title: 'Action Taken By',
      dataIndex: 'actionTakenBy',
      key: 'actionTakenBy',
      width: 150,
    },
    {
      title: 'Request Id',
      dataIndex: 'requestId',
      key: 'requestId',
      width: 150,
      render: (text: any, record: any) => {
        return <span>{record.requestId ? record.requestId : record.changeReason}</span>;
      },
    },
  ];

  return (
    <Modal
      title="Audit Log"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
          zIndex: 9998,
        },
      }}
    >
      <div>
        <div>
          <p>
            <b>User Name:</b> {selectedemployeeData?.name}
          </p>
          <p>
            <b>User Email:</b> {selectedemployeeData?.email}
          </p>
        </div>
        <Table
          dataSource={auditLogData}
          columns={columns}
          scroll={{ x: 'max-content', y: 300}}
          className='table-style'
          loading={userDashboard?.loading}
          pagination={{
            current: pageNo + 1,
            pageSize,
            total: totalCount,
            showSizeChanger: false
          }}
          onChange={handleTableChange}
        />
      </div>
    </Modal>
  );
};

export default AuditLogModal;